import { Component, Input } from '@angular/core';

@Component({
  selector: 'ex-pill',
  templateUrl: './ex-pill.component.html',
  styleUrls: ['./ex-pill.component.scss'],
})
export class ExPillComponent {
  @Input() variant: 'neutral' | 'info' | 'success' | 'warning' = 'neutral';

  @Input() phosphorIcon?: string;

  @Input() showSpinner = false;
}
